/**
 * Figma Scroll to Section Utility
 * Provides smooth scrolling from [data-scroll-target] elements to their targets.
 */

(() => {
  const abortController = new AbortController();
  const signal = abortController.signal;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = () => {
    document.querySelectorAll('[data-scroll-target]').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();

        const targetId = button.getAttribute('data-scroll-target');
        const target = document.getElementById(targetId)
          || document.querySelector(`[data-section-id="${targetId}"]`)
          || document.querySelector(`[id$="__${targetId}"]`);

        if (!target) return;

        const header = document.querySelector('#SiteHeader, header.header');
        const offset = header ? header.offsetHeight : 0;

        window.scrollTo({
          top: Math.max(0, target.offsetTop - offset),
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });

        if (target.tabIndex < 0 && !target.hasAttribute('tabindex')) {
          target.setAttribute('tabindex', '-1');
        }
        target.focus({ preventScroll: true });
      }, { signal });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { signal });
  } else {
    init();
  }
})();
